import React, { useState, useEffect, useContext } from "react";
import PageTitle from "../../../../jsx/layouts/PageTitle";
import { Button } from "react-bootstrap";
import BatchList from "./BatchList";
import ReactPaginate from "react-paginate";
import "./Batch.css";
import { getAllSportList, getAllDistrictList } from "../../../../services/commonApiService/CommonApiService";
import { getBatchList } from "../../../../services/adminApiService/batchManagementApi/BatchManagementApiService";
import { Link } from "react-router-dom";
import { AuthContext } from "../../../../context/AuthContext";

const Index = () => {
    const { user, userData } = useContext(AuthContext);
    const isDSO = user?.user_level === "3";
    const isCoach = localStorage.getItem("category_type") === "2";

    const [searchValue, setSearchValue] = useState("");
    const [sportFilter, setSportFilter] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage] = useState(10);

    const [clusterFilter, setClusterFilter] = useState("");
    const [clusterList, setClusterList] = useState([]);
    const [clusterLoading, setClusterLoading] = useState(false);

    const [sportsList, setSportsList] = useState([]);
    const [sportsLoading, setSportsLoading] = useState(false);

    const [batchList, setBatchList] = useState([]);
    const [batchLoading, setBatchLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [refreshKey, setRefreshKey] = useState(0);

    const refreshList = () => setRefreshKey(prev => prev + 1);

    // ================= CLUSTER API =================
    useEffect(() => {
        const fetchClusterList = async () => {
            try {
                setClusterLoading(true);
                const response = await getAllDistrictList(4016);
                const list = response?.data || [];
                setClusterList(list);
                if (isDSO && userData?.district_id) {
                    const match = list.find(
                        (c) => String(c.id) === String(userData.district_id)
                    );
                    if (match) setClusterFilter(match.name);
                } else if (isCoach && userData?.district_id) {
                    const match = list.find(
                        (c) => String(c.id) === String(userData.district_id)
                    );
                    if (match) setClusterFilter(match.name);
                }
            } catch (error) {
                console.error("Error fetching cluster list:", error);
            } finally {
                setClusterLoading(false);
            }
        };
        fetchClusterList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // ================= SPORTS API =================
    useEffect(() => {
        const fetchSportsList = async () => {
            try {
                setSportsLoading(true);
                const response = await getAllSportList();
                setSportsList(response?.data?.data || []);
            } catch (error) {
                console.error("Error fetching sports list:", error);
            } finally {
                setSportsLoading(false);
            }
        };

        fetchSportsList();
    }, []);

    // ================= BATCH LIST API =================
    const fetchBatchList = async () => {
        try {
            setBatchLoading(true);

            const payload = {
                search: searchValue,
                sports_id: sportFilter,
                cluster: clusterFilter,
            };

            const response = await getBatchList(currentPage, perPage, payload);

            // Correct data path
            setBatchList(response?.data?.data || []);

            // Correct pagination path
            setTotalRecords(response?.data?.pagination?.total || 0);

        } catch (error) {
            console.error("Error fetching batch list:", error);
        } finally {
            setBatchLoading(false);
        }
    };
    

    useEffect(() => {
        fetchBatchList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, searchValue, sportFilter, clusterFilter, refreshKey]);

    const handlePageChange = (event) => {
        setCurrentPage(event.selected + 1);
    };

    return (
        <>
            <PageTitle activeMenu="Batches" motherMenu="Batch Management" />

            <div className="col-12">
                <div className="card">
                    <div className="card-header">
                        <div className="row g-2 align-items-center">
                            <div className="col-12 col-md-4">
                                <input
                                    type="text"
                                    placeholder="Search by name, sport..."
                                    className="form-control"
                                    value={searchValue}
                                    onChange={(e) => {
                                        setCurrentPage(1);
                                        setSearchValue(e.target.value);
                                    }}
                                />
                            </div>

                            <div className="col-6 col-md-3">
                                <select
                                    className="form-select"
                                    value={sportFilter}
                                    onChange={(e) => {
                                        setCurrentPage(1);
                                        setSportFilter(e.target.value);
                                    }}
                                    disabled={sportsLoading}
                                >
                                    {sportsLoading ? (
                                        <option>Loading sports...</option>
                                    ) : (
                                        <>
                                            <option value="">All Sport</option>
                                            {sportsList.map((item) => (
                                                <option key={item.id} value={item.sport_id}>
                                                    {item.sport_name}
                                                </option>
                                            ))}
                                        </>
                                    )}
                                </select>
                            </div>

                            <div className="col-6 col-md-3">
                                <select
                                    className="form-select"
                                    value={clusterFilter}
                                    onChange={(e) => {
                                        setCurrentPage(1);
                                        setClusterFilter(e.target.value);
                                    }}
                                    disabled={clusterLoading || isDSO || isCoach}
                                >
                                    {clusterLoading ? (
                                        <option>Loading clusters...</option>
                                    ) : (
                                        <>
                                            <option value="">All Cluster</option>
                                            {clusterList.map((item) => (
                                                <option key={item.id} value={item.name}>
                                                    {item.name}
                                                </option>
                                            ))}
                                        </>
                                    )}
                                </select>
                            </div>

                            <div className="col-12 col-md-2 d-grid">
                                <Link to="/batch-management/batches/add">
                                    <Button variant="primary" className="w-100">
                                        + Create Batch
                                    </Button>
                                </Link>
                            </div>
                        </div>
                    </div>

                    <BatchList
                        batchList={batchList}
                        loading={batchLoading}
                        refreshList={refreshList}
                    />
                </div>
            </div>
            <ReactPaginate
                nextLabel="next >"
                onPageChange={handlePageChange}
                pageRangeDisplayed={5}
                marginPagesDisplayed={2}
                pageCount={Math.ceil(totalRecords / perPage)}
                previousLabel="< previous"
                containerClassName="pagination d-flex flex-wrap"
                activeClassName="active"
                pageClassName="page-item mx-1 my-1"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link mx-1 my-1"
                nextClassName="page-item mx-1 my-1"
                nextLinkClassName="page-link"
                breakLabel="..."
                breakClassName="page-item mx-1 my-1"
                breakLinkClassName="page-link"
                forcePage={currentPage - 1}
            />
        </>
    );
};

export default Index;